if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;

        this.form.addEventListener(
          'submit',
          this.onSubmitHandler.bind(this)
        );

        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        this.submitButton =
          this.querySelector('[type="submit"]');

        this.submitButtonText =
          this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute(
            'aria-haspopup',
            'dialog'
          );
        }

        this.hideErrors =
          this.dataset.hideErrors === 'true';
      }


      onSubmitHandler(evt) {
        evt.preventDefault();

        if (
          this.submitButton.getAttribute(
            'aria-disabled'
          ) === 'true'
        ) {
          return;
        }


        this.handleErrorMessage();


        this.submitButton.setAttribute(
          'aria-disabled',
          true
        );

        this.submitButton.classList.add(
          'loading'
        );

        this.querySelector(
          '.loading__spinner'
        ).classList.remove(
          'hidden'
        );


        const config =
          fetchConfig('javascript');

        config.headers['X-Requested-With'] =
          'XMLHttpRequest';

        delete config.headers['Content-Type'];


        /*
         * ==========================================
         * FORM DATA
         * ==========================================
         */

        const formData =
          new FormData(this.form);


        /*
         * ==========================================
         * ALPAKA STORE – SOCKEN MENGENWAHL
         * ==========================================
         *
         * Der Custom-Liquid-Block auf der
         * Socken-PDP schreibt z.B.:
         *
         * data-as-quantity="3"
         *
         * auf das Produktformular.
         *
         * Hier übernehmen wir diese Menge direkt
         * in den tatsächlichen Add-to-Cart Request.
         *
         * Wenn kein data-as-quantity vorhanden ist,
         * verhält sich Dawn exakt wie vorher.
         * ==========================================
         */

        const customQuantity =
          this.form.dataset.asQuantity;


        if (customQuantity) {

          const parsedQuantity =
            parseInt(
              customQuantity,
              10
            );


          if (
            Number.isInteger(parsedQuantity) &&
            parsedQuantity > 0
          ) {

            formData.set(
              'quantity',
              String(parsedQuantity)
            );

          }

        }


        /*
         * ==========================================
         * CART DRAWER / CART NOTIFICATION
         * ==========================================
         */

        if (this.cart) {

          formData.append(
            'sections',
            this.cart
              .getSectionsToRender()
              .map(
                (section) =>
                  section.id
              )
          );


          formData.append(
            'sections_url',
            window.location.pathname
          );


          this.cart.setActiveElement(
            document.activeElement
          );

        }


        config.body =
          formData;


        /*
         * ==========================================
         * ADD TO CART
         * ==========================================
         */

        fetch(
          `${routes.cart_add_url}`,
          config
        )

          .then(
            (response) =>
              response.json()
          )

          .then(
            (response) => {

              /*
               * ======================================
               * FEHLER
               * ======================================
               */

              if (response.status) {

                publish(
                  PUB_SUB_EVENTS.cartError,
                  {
                    source:
                      'product-form',

                    productVariantId:
                      formData.get('id'),

                    errors:
                      response.errors ||
                      response.description,

                    message:
                      response.message,
                  }
                );


                this.handleErrorMessage(
                  response.description
                );


                const soldOutMessage =
                  this.submitButton.querySelector(
                    '.sold-out-message'
                  );


                if (!soldOutMessage) {
                  return;
                }


                this.submitButton.setAttribute(
                  'aria-disabled',
                  true
                );


                this.submitButtonText.classList.add(
                  'hidden'
                );


                soldOutMessage.classList.remove(
                  'hidden'
                );


                this.error =
                  true;


                return;

              }


              /*
               * ======================================
               * KEIN CART DRAWER
               * ======================================
               */

              else if (!this.cart) {

                window.location =
                  window.routes.cart_url;


                return;

              }


              /*
               * ======================================
               * CART UPDATE EVENT
               * ======================================
               */

              const startMarker =
                CartPerformance.createStartingMarker(
                  'add:wait-for-subscribers'
                );


              if (!this.error) {

                publish(
                  PUB_SUB_EVENTS.cartUpdate,
                  {
                    source:
                      'product-form',

                    productVariantId:
                      formData.get('id'),

                    cartData:
                      response,
                  }
                )

                  .then(
                    () => {

                      CartPerformance.measureFromMarker(
                        'add:wait-for-subscribers',
                        startMarker
                      );

                    }
                  );

              }


              this.error =
                false;


              /*
               * ======================================
               * QUICK ADD MODAL
               * ======================================
               */

              const quickAddModal =
                this.closest(
                  'quick-add-modal'
                );


              if (quickAddModal) {

                document.body.addEventListener(
                  'modalClosed',

                  () => {

                    setTimeout(
                      () => {

                        CartPerformance.measure(
                          'add:paint-updated-sections',

                          () => {

                            this.cart.renderContents(
                              response
                            );

                          }
                        );

                      }
                    );

                  },

                  {
                    once: true
                  }
                );


                quickAddModal.hide(
                  true
                );

              }


              /*
               * ======================================
               * NORMALER CART DRAWER
               * ======================================
               */

              else {

                CartPerformance.measure(
                  'add:paint-updated-sections',

                  () => {

                    this.cart.renderContents(
                      response
                    );

                  }
                );

              }

            }
          )


          /*
           * ==========================================
           * FETCH FEHLER
           * ==========================================
           */

          .catch(
            (e) => {

              console.error(
                e
              );

            }
          )


          /*
           * ==========================================
           * ABSCHLUSS
           * ==========================================
           */

          .finally(
            () => {

              this.submitButton.classList.remove(
                'loading'
              );


              if (
                this.cart &&
                this.cart.classList.contains(
                  'is-empty'
                )
              ) {

                this.cart.classList.remove(
                  'is-empty'
                );

              }


              if (!this.error) {

                this.submitButton.removeAttribute(
                  'aria-disabled'
                );

              }


              this.querySelector(
                '.loading__spinner'
              ).classList.add(
                'hidden'
              );


              CartPerformance.measureFromEvent(
                'add:user-action',
                evt
              );

            }
          );

      }


      /*
       * ==========================================
       * ERROR MESSAGE
       * ==========================================
       */

      handleErrorMessage(
        errorMessage = false
      ) {

        if (this.hideErrors) {
          return;
        }


        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            '.product-form__error-message-wrapper'
          );


        if (!this.errorMessageWrapper) {
          return;
        }


        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );


        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );


        if (errorMessage) {

          this.errorMessage.textContent =
            errorMessage;

        }

      }


      /*
       * ==========================================
       * SUBMIT BUTTON
       * ==========================================
       */

      toggleSubmitButton(
        disable = true,
        text
      ) {

        if (disable) {

          this.submitButton.setAttribute(
            'disabled',
            'disabled'
          );


          if (text) {

            this.submitButtonText.textContent =
              'Nicht verfügbar';

          }

        }

        else {

          this.submitButton.removeAttribute(
            'disabled'
          );


          this.submitButtonText.textContent =
            'In den Warenkorb legen';

        }

      }


      /*
       * ==========================================
       * VARIANT ID INPUT
       * ==========================================
       */

      get variantIdInput() {

        return this.form.querySelector(
          '[name=id]'
        );

      }

    }
  );
}